module.exports = __webpack_public_path__ + "img/arrow-diaganol.97b5ad6b.svg";